import { Directive, Input, OnChanges, OnDestroy, OnInit, inject } from '@angular/core';
import { AppointmentActivity } from '@omni/classes/activity/appointment.activity.class';
import { NovaContext, NovaContextService } from './nova-context.service';

/**
 * Plugs meeting context into Nova while the host element is alive, and unplugs
 * it on destroy — so leaving the meeting screen drops Meeting mode and stops
 * transcription automatically. Place on the long-lived meeting container.
 *
 *   <ion-content [novaMeetingContext]="selectedActivity"> ... </ion-content>
 */
@Directive({
  selector: '[novaMeetingContext]',
  standalone: true,
})
export class NovaMeetingContextDirective implements OnInit, OnChanges, OnDestroy {
  @Input('novaMeetingContext') activity: AppointmentActivity | null = null;

  readonly #svc = inject(NovaContextService);
  #ctx: NovaContext | null = null;

  ngOnInit(): void {
    this.#plug();
  }

  ngOnChanges(): void {
    if (this.#ctx && this.#ctx.kind === 'meeting' && this.#ctx.activity !== this.activity) {
      this.#unplug();
      this.#plug();
    }
  }

  ngOnDestroy(): void {
    this.#unplug();
  }

  #plug(): void {
    if (!this.activity || this.#ctx) return;
    this.#ctx = { kind: 'meeting', activity: this.activity };
    this.#svc.plug(this.#ctx);
  }

  #unplug(): void {
    if (!this.#ctx) return;
    this.#svc.unplug(this.#ctx);
    this.#ctx = null;
  }
}
